import React, { useEffect, useState } from 'react';
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import axios from 'axios';
import { BASE_URL } from '../../config/axios';
import { Spinner } from 'react-bootstrap';

function SearchTender() {
    const emp_code = sessionStorage.getItem('sitemanagement_emp_code');

    const [state, setState] = useState({
        websites: [],
        loading: true,
        tab: 'central',
    });

    // ✅ color based on open timing
    const getColorBasedOnTime = (lastOpened) => {

        const now = new Date();
        const openedDate = new Date(lastOpened);
        console.log(now, lastOpened)
        const diffHours = (now - openedDate) / (1000 * 60 * 60);
        console.log(diffHours, 'diffhours')
        if (diffHours <= 24) return 'green';
        else if (diffHours > 72) return 'red';
        else return 'black';
    };

    // ✅ Fetch both site list and open log
    const handleGetSitesAndLastOpenedData = async () => {
        setState((prev) => ({ ...prev, loading: true }));
        try {
            const [sitesRes, trackingRes] = await Promise.all([
                axios.get(`${BASE_URL}/siteproject/trackedurls/`),
                axios.get(`${BASE_URL}/siteproject/trackedURLOpenLogfilter/${emp_code}/`),
            ]);

            const documents = sitesRes.data;
            const trackingInfo = trackingRes.data;

            const mergedData = documents.map((doc) => {
                const match = trackingInfo.find((t) => t.tracked_url === doc.id);
                return {
                    ...doc,
                    last_opened_at: match?.last_opened_at || null,
                    obj_id: match?.id || null,
                };
            });

            setState((prev) => ({ ...prev, websites: mergedData }));
        } catch (error) {
            console.error('Failed to fetch sites or tracking info', error);
        } finally {
            setState((prev) => ({ ...prev, loading: false }));
        }
    };

    useEffect(() => {
        handleGetSitesAndLastOpenedData();
    }, []);

    // ✅ tab change
    const handleTabChange = (val) => {
        setState((prev) => ({ ...prev, tab: val }));
    };

    // ✅ Update open log when clicked
    const handleClickOnLink = async (id, openedId) => {
        try {
            let res;
            if (openedId) {
                res = await axios.put(`${BASE_URL}/siteproject/trackedURLOpenLog/${openedId}/`, {
                    tracked_url: id,
                    last_opened_by: emp_code,
                });
            } else {
                res = await axios.post(`${BASE_URL}/siteproject/trackedURLOpenLog/`, {
                    tracked_url: id,
                    last_opened_by: emp_code,
                });
            }

            const web = state.websites.find((web) => web.id === res.data.tracked_url);
            const updatedWebsites = [
                ...state.websites.filter((web) => web.id !== res.data.tracked_url),
                { ...web, last_opened_at: res.data.last_opened_at, obj_id: res.data.id },
            ];

            setState((prev) => ({ ...prev, websites: updatedWebsites }));
        } catch (err) {
            console.error(err);
        }
    };

    // ---------------------------------------------------
    // 🧠 Categorization logic
    // ---------------------------------------------------
    const centralKeywords = [
        'etenders.gov.in',
        'eprocure.gov.in',
        'defproc.gov.in',
        'tenderwizard.in',
        'rlda.indianrailways.gov.in',
        'ireps.gov.in',
        'nhai',
        'morth',
        'bro',
        'rlda',
        'ireps',
    ];

    const stateKeywords = [
        'bihar',
        'uttar',
        'maharashtra',
        'gujarat',
        'tamil',
        'karnataka',
        'rajasthan',
        'odisha',
        'kerala',
        'punjab',
        'madhya',
        'andhra',
        'telangana',
        'jharkhand',
        'haryana',
        'chhattisgarh',
        'west bengal',
        'assam',
        'goa',
        'manipur',
        'mizoram',
        'nagaland',
        'sikkim',
        'tripura',
        'meghalaya',
        'arunachal',
        'delhi',
        'himachal',
        'andaman',
        'wb',
        'mp',
        'j&k',
    ];

    const getCategory = (site) => {
        const url = site.url?.toLowerCase() || '';
        const name = site.name?.toLowerCase() || '';

        // Central → if matches any central keyword
        if (centralKeywords.some((key) => url.includes(key) || name.includes(key))) return 'central';
        const otherKeywords = [
            "others"
        ];
        if (otherKeywords.some((key) => url.includes(key) || name.includes(key))) {
            return 'other';
        }
        // Everything else → State
        return 'state';
    };

    const getStateName = (site) => {
        const url = site.url?.toLowerCase() || '';
        const name = site.name?.toLowerCase() || '';
        const found = stateKeywords.find((key) => url.includes(key) || name.includes(key));
        return found ? found.charAt(0).toUpperCase() + found.slice(1) : null;
    };

    // ✅ Filtered list based on tab
    const filteredSites = state.websites.filter((site) => {
        const category = getCategory(site);
        if (state.tab === 'central') return category === 'central';
        if (state.tab === 'state') return category === 'state';
        if (state.tab === 'other') return category === 'other';
        return true;
    });

    // ✅ Categorize opened stats (per tab)
    const categorizeByLastOpened = () => {
        const now = new Date();

        let result = {
            within24: 0,
            within72: 0,
            others: 0,
        };

        filteredSites.forEach((item) => {
            const openedDate = new Date(item.last_opened_at);
            if (isNaN(openedDate)) {
                result.others++;
                return;
            }
            const diffInHours = (now - openedDate) / (1000 * 60 * 60);
            if (diffInHours <= 72) result.within72++;
            else result.others++;
        });

        return result;
    };

    const stats = categorizeByLastOpened();

    // ---------------------------------------------------
    // 🖼️ UI
    // ---------------------------------------------------
    return (
        <div style={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Dashboardnavbar name="Search Tender" url="searchTender" />

            {/* Summary Stats */}
            <div
                style={{
                    width: '97%',
                    display: 'flex',
                    flexWrap: 'wrap',
                    background: '#fff',
                    borderRadius: '4px',
                    padding: '12px',
                    gap: '12px',
                    marginBottom: '12px',
                    marginLeft: '0.5%',
                }}
            >
                <div style={{ minWidth: '80px', padding: '8px', borderRadius: '4px', backgroundColor: '#F4F7FE', display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '16px' }}>Opened In Last 3 Days</label>
                    <label style={{ fontSize: '22px', fontWeight: 500 }}>{stats.within72}</label>
                </div>
                <div style={{ minWidth: '80px', padding: '8px', borderRadius: '4px', backgroundColor: '#F4F7FE', display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '16px' }}>Not Opened</label>
                    <label style={{ fontSize: '22px', fontWeight: 500 }}>{stats.others}</label>
                </div>
                <div
                    style={{
                        marginLeft: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'end',
                        gap: '10px',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <label>Opened In Last 3 Days</label>
                        <div style={{ width: '1rem', height: '1rem', borderRadius: '50%', backgroundColor: 'green' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <label>Not Opened</label>
                        <div style={{ width: '1rem', height: '1rem', borderRadius: '50%', backgroundColor: 'red' }} />
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div
                style={{
                    width: '97.5%',
                    padding: '8px',
                    borderRadius: '4px',
                    backgroundColor: '#fff',
                    marginBottom: '12px',
                    marginLeft: '0.5%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                }}
            >
                <div onClick={() => handleTabChange('central')} className={`serch-sites-tab-btn ${state.tab === 'central' ? 'active' : ''}`}>
                    Central Sites
                </div>
                <div onClick={() => handleTabChange('state')} className={`serch-sites-tab-btn ${state.tab === 'state' ? 'active' : ''}`}>
                    State Sites
                </div>
                <div onClick={() => handleTabChange('other')} className={`serch-sites-tab-btn ${state.tab === 'other' ? 'active' : ''}`}>
                    Other Sites
                </div>
            </div>

            {/* Table */}
            <div className="table-css-white-background table-box scroll-container-table" style={{ paddingTop: '0px', width: '97%', margin: '0 auto' }}>
                {state.loading ? (
                    <div className="table-css-white-background table-box scroll-container-table">
                        <Spinner />
                    </div>
                ) : (
                    <table className="table-css">
                        <thead className="table-heading">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text text-left">Website Name</th>
                                <th className="table-heading-text text-left">Website Link</th>
                                <th className="table-heading-text text-left">Last Opened</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredSites.map((site) => {
                                const color = getColorBasedOnTime(site.last_opened_at);
                                const stateName = getStateName(site);
                                return (
                                    <tr key={site.id} className="custom-table-head-td">
                                        <td className="text-left">
                                            {site.name}
                                            {state.tab === 'state' && stateName ? ` (${stateName})` : ''}
                                        </td>
                                        <td className="text-left">
                                            <a
                                                href={site.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color }}
                                                onClick={() => handleClickOnLink(site.id, site.obj_id)}
                                            >
                                                {site.url}
                                            </a>
                                        </td>
                                        <td className="text-left">
                                            {(() => {
                                                const d = new Date(site.last_opened_at);
                                                return isNaN(d.getTime()) || d.getFullYear() === 1970
                                                    ? "N/A"
                                                    : d.toLocaleString();
                                            })()}
                                        </td>

                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}

export default SearchTender;
